import React from 'react';
import logComponent from '../../common/logComponent';

export default function CardLink({ children }) {
  if (logComponent('CardLink')) { console.debug('CardLink rendered'); }

  return (<div className="Card__link">{children}</div>);
}
